import type { ConnectionTestResult } from '@pa/api/admin'
import { CircleAlert, CircleCheck, CircleX } from 'lucide-react'
import { testSummary } from '../model/connection'

const Check = ({ ok, label }: { ok: boolean; label: string }) => (
  <li className={ok ? 'ok' : 'no'}>
    {ok ? <CircleCheck aria-hidden /> : <CircleX aria-hidden />}
    <span>
      {label}
      <span className="sr-only">{ok ? ': yes' : ': no'}</span>
    </span>
  </li>
)

/** The Test connection result fields (API.md §7.10): S-03 and S-04 Connection. */
export function ConnectionResult({ result }: { result: ConnectionTestResult }) {
  const tested = new Date(result.testedAt).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' })
  return (
    <section className="form-grid" aria-label="Test connection result">
      <p className={result.error === null ? '' : 'err-text'} role="status">
        <b>{testSummary(result)}</b> <span className="muted">· {tested}</span>
      </p>
      <ul className="check-items">
        <Check ok={result.reachable} label="Reachable" />
        <Check ok={result.authenticated} label="API key accepted" />
        <Check ok={result.pfLoggedIn} label="Practice Fusion logged in" />
        <Check ok={result.apiReady} label="API ready" />
      </ul>
      <dl className="kv">
        <dt>Keeper version</dt>
        <dd>{result.keeperVersion ?? '—'}</dd>
        <dt>Latency</dt>
        <dd>{result.latencyMs === null ? '—' : `${String(result.latencyMs)} ms`}</dd>
        <dt>Booking</dt>
        <dd>{result.bookingEnabled === null ? '—' : result.bookingEnabled ? 'Enabled' : 'Turned off in PF Keeper'}</dd>
        <dt>PF time zone</dt>
        <dd>{result.pfTimeZone ?? '—'}</dd>
      </dl>
      {result.timeZoneMatches === false && (
        <div className="warn-box">
          <CircleAlert aria-hidden />
          <p>Practice Fusion uses {result.pfTimeZone}, which differs from this clinic&apos;s time zone.</p>
        </div>
      )}
    </section>
  )
}
